import { Component, OnDestroy, OnInit, ViewChild, Inject, afterNextRender } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { UserDetailComponent } from './tabs/user-detail.component.js';
import { UserMetricsComponent } from './tabs/user-metrics.component.js';
import { UserFeedbackComponent } from './tabs/user-feedback.component.js';
import { UserVoiceMacroComponent } from './tabs/user-macros.component.js';
/** The organizations list page */
@Component({
	selector: 'app-user',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		UserDetailComponent,
		UserMetricsComponent,
		UserFeedbackComponent,
		UserVoiceMacroComponent

	],
	templateUrl: './user.component.html',
	styleUrl: './user.component.scss'
})
export class UserComponent implements OnInit, OnDestroy {

	constructor() {
	}

	ngOnInit() {
	}

	private refresh() {
	}

	ngOnDestroy() {
	}
}
